import { memo } from 'react';
import { useTheme } from '@mui/material';
import ConnectHealthRecordsIllustrationLight from './connectHealthRecords.svg?react';
import ConnectHealthRecordsIllustrationDark from './connectHealthRecords_dark.svg?react';

export const ConnectHealthRecordsIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return (
        <ConnectHealthRecordsIllustrationDark aria-hidden="true" {...props} />
      );
    return (
      <ConnectHealthRecordsIllustrationLight aria-hidden="true" {...props} />
    );
  },
);
